import { AntDesign } from "@expo/vector-icons";
import { BlurView } from "expo-blur";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { View, Modal, Pressable, Text } from "react-native";

import LoginImage from "@/assets/login.svg";
import Subtitle from "@/components/Subtitle";
import Title from "@/components/Title";
import Button from "@/components/button/Button";

interface SessionExpiredModalProps {
  visible: boolean;
  onClose: () => void;
}

export default function SessionExpiredModal(props: SessionExpiredModalProps) {
  const { t } = useTranslation();

  return (
    <Modal visible={props.visible} transparent animationType="fade">
      <BlurView intensity={20} className="flex-1 justify-center items-center">
        <View className="p-6 bg-white1 border border-gray rounded-lg w-full h-full items-center justify-center shadow relative lg:w-104 lg:h-136 lg:justify-start">
          <Pressable className="absolute right-3 top-3" onPress={props.onClose}>
            <AntDesign name="close" size={24} color="black" />
          </Pressable>
          <View className="flex-grow items-center justify-center lg:justify-start">
            <View className="my-2 gap-2">
              <Title text={t("common:modal.sessionexpired.title")} />
              <Text className="text-black font-light text-center text-xl">
                {t("common:modal.sessionexpired.content")}
              </Text>
            </View>
            <View className="w-full flex-grow items-center justify-center">
              <LoginImage width={240} height={200} />
            </View>
          </View>
          <Button
            label={t("common:button.confirm")}
            onClick={() => props.onClose()}
          />
        </View>
      </BlurView>
    </Modal>
  );
}
